import React from 'react'

import Container from 'react-bootstrap/Container';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { Link } from 'react-router-dom';
import logo from './Image2/logo.jpg'


const Navbarss = () => {
    return (
        <Navbar collapseOnSelect expand="xl" bg="light" variant="light" fixed="top" className="height card-5" >
        <Container  >
          <Navbar.Brand href="/" className='d-flex'><img src={logo} alt="logo" style={{width:"100px" , height:"80px" }}></img><p className='mt-3 mx-3' style={{fontSize:"19px"}}> Shinde Institute of Pharmacy<br></br>  and Research </p> </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
         
            <Nav className="ms-auto">
            <Nav.Link href="/" className="h5"><Link to="/" className="color text-dark hover-underline-animation">Home</Link></Nav.Link>
            <Nav.Link href="/" className="h5"><Link to="/about" className="color text-dark">About Us</Link></Nav.Link>
            <Nav.Link href="/" className="h5"><Link to="/admission" className="color text-dark">Admission</Link></Nav.Link>
            {/* <NavDropdown title="Drop" id="collasible-nav-dropdown" className="h5">
                <NavDropdown.Item href="#action/3.1" className="h5">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2" className="h5">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3" className="h5">Something</NavDropdown.Item>
              </NavDropdown> */}
              <Nav.Link href="/" className="h5"><Link to="/facillities" className="color text-dark">Facillities</Link></Nav.Link>
            <Nav.Link href="/" className="h5"><Link to="/gallery" className="color text-dark" >Gallery</Link></Nav.Link>
            <Nav.Link href="/" className="h5"><Link to="/contactus" className="color text-dark">Contact Us</Link></Nav.Link>
      
            
            </Nav>
        
          </Navbar.Collapse>
        </Container>
      </Navbar>
      );
}

export default Navbarss